
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Die Todesfälle lassen sich auf die gleiche Weise betrachten: die Anzahl
Verstorbener pro Tag verglichen mit der Anzahl aller Toten. Hervorgehoben sind
in dieser Grafik Länder, die insgesamt `}<strong parentName="p">{`mehr als 1500 durch Covid-19
verursachte Tote`}</strong>{` beklagen müssen und es geschafft haben, den `}<strong parentName="p">{`täglichen
Zuwachs auf unter 0,5 Prozent`}</strong>{` des Totals zu drücken.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;